import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Axios from "axios";
import { host } from '../../inv';

// const PATH  = "http://localhost:8080";
const PATH  = "";

export const formatDate = date => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export const login = (data, callback) => {
  Axios.post(
    host  + "/user/login", data
  ).then(res => callback(res.data));
};

export const changePassword = (data, callback) => {
  Axios.post(host  + "/user/changepassword", data).then(res => callback(res.data));
};

export const getSession = callback => {
  Axios.get(host  + "/user/getsession").then(res => callback(res.data));
};

export const getMonthsMenu = () => {
  return (
    <React.Fragment>
      <MenuItem value={"Jan"} primaryText={"Jan"} />
      <MenuItem value={"Feb"} primaryText={"Feb"} />
      <MenuItem value={"Mar"} primaryText={"Mar"} />
      <MenuItem value={"Apr"} primaryText={"Apr"} />
      <MenuItem value={"May"} primaryText={"May"} />
      <MenuItem value={"June"} primaryText={"June"} />
      <MenuItem value={"July"} primaryText={"July"} />
      <MenuItem value={"Aug"} primaryText={"Aug"} />
      <MenuItem value={"Sep"} primaryText={"Sep"} />
      <MenuItem value={"Oct"} primaryText={"Oct"} />
      <MenuItem value={"Nov"} primaryText={"Nov"} />
      <MenuItem value={"Dec"} primaryText={"Dec"} />
    </React.Fragment>
  );
};

export const privilegeChecker = (privileges, roleType, id) => {
  if (privileges)
    for (let index = 0; index < privileges.length; index++) {
      const element = privileges[index];
      if (element == id) return true;
    }
    return false;
};


export const  getDaysInMonth = (month, year) => {
  let date = new Date(year, month, 1);
  let days = [];
  while (date.getMonth() === month) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }

  let daysFormat = [];
  let dateFormat = '';
  for (let i = 0; i < days.length; i++) {
    dateFormat = new Date(days[i]);
    daysFormat.push({
      'year': new Intl.DateTimeFormat('en', { year: 'numeric' }).format(dateFormat),
      'month': new Intl.DateTimeFormat('en', { month: 'numeric' }).format(dateFormat),
      'day': new Intl.DateTimeFormat('en', { day: 'numeric' }).format(dateFormat),
      'day2': dateFormat.getDay(),
    }) 
  }

  return { days, daysFormat };
}

export const monthNames = 
    ["January", "February", "March", "April", "May", "June", "July", "August", 
    "September", "October", "November", "December"];

export const daysName = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const getPostsByLanguage = (language, callback) => {
  Axios.get(host + "/post/getpostsbylanguage/" + language).then(res =>
    callback(res.data)
  );
};

export const languageConvertor = (language) => {
  if (language == 2) {  return 'En'; } 
  else if (language == 1) { return 'Ar'; } 
  else { return 'Kr' }
}